import React, { useEffect, useRef, useState } from "react";
import {
  Row,
  Col,
  Table,
  Spin,
  Form,
  Select,
  Tooltip,
  Modal,
  message,
  Button,
  Tabs,
} from "antd";
import styled from "@emotion/styled";
import AttendanceBarChart from "molecules/AttendanceBarChart";
import LocationBasedPresentStaff from "molecules/LocationBasedPresentStaff";
import { CALL_API, CALL_FEATCH_API } from "common/API";
import { getColor, LEAVE_ICON, STATUS_CODE } from "common/Constants";
import { includes, concat, orderBy, some } from "lodash";
import COLORS from "common/Colors";
import moment from "moment";
import LeaveFormModel from "organisms/LeaveFormModel";
import ViewMore from "organisms/ViewMore";
import { EyeFilled, BellFilled } from "@ant-design/icons";
import { getMySqlDate } from "utils/Date";
import LeaveDonutChart from "molecules/LeaveDonutChart";
import DepartmentStaffLeaveBalance from "molecules/DepartmentStaffLeaveBalance";
import { getLoadingRoute, getCRMManagingOfficeList, getLocations, getCountryFilterResourcePlanningList } from "redux/selectors";
import { connect, useSelector } from "react-redux";
import { uniqBy } from "lodash";
import { DropdownCheckBox } from "atoms/UIDropdown/Dropdown";
import { CSVLink } from "react-csv";
import { reduce } from "lodash";
import { PaperClipOutlined } from "@ant-design/icons";

const StyledRow = styled(Row)`
  padding-top: 20px;
`;

const StyledLeaveContainer = styled.div`
  padding: 12px 20px 20px 20px !important;
  box-shadow: rgba(0, 0, 0, 0.15) 0px 5px 15px;
  border-radius: 5px !important;
  padding-bottom: 25px;
  margin: 0px !important;
`;

const StyledChartContainer = styled.div`
  padding: 20px !important;
  box-shadow: rgba(0, 0, 0, 0.15) 0px 5px 15px;
  border-radius: 5px !important;
  padding-bottom: 25px;
  margin: 0px !important;
`;

const StyledTitle = styled.div`
  font-size: 1rem;
  font-weight: 600;
  color: #141414;
  margin-right: auto;
`;
const StyledTable = styled(Table)`
  padding-top: 20px;
  table {
    width: 100% !important;
  }
  tr.ant-table-row:hover > td {
    background: hsla(0, 0%, 90%, 0.5);
    cursor: pointer;
  }
  .ant-table-content {
    overflow-x: auto;
    white-space: nowrap;
  }
  .ant-table-cell {
    padding: 20px;
  }
  .normal-column {
    min-width: 300px;
    white-space: normal;
  }
  .ant-table-thead .ant-table-cell {
    font-weight: 600;
    font-size: 0.9rem;
    color: ${COLORS.SECONDARY_BLACK};
    white-space: nowrap;
  }
  .non-white {
    background: #f9f9f9;
  }
`;

const StyledLoader = styled.div`
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
`;

const ButtonOutlined = styled(Button)`
  padding: 5px 20px;
  border: 1px solid ${COLORS.PRIMARY};
  border-radius: 5px;
  background: transparent;
  font-weight: normal;
  color: ${COLORS.PRIMARY};
  white-space: nowrap;

  &:hover {
    border: 1px solid ${COLORS.PRIMARY};
    background: #f1f3f4;
    color: ${COLORS.PRIMARY};
  }
  &:focus {
    border: 1px solid ${COLORS.PRIMARY};
    background: #f1f3f4;
    color: ${COLORS.PRIMARY};
  }
  @media (max-width: 900px) {
    margin: 10px 0px;
  }
`;

function HrDashboard({
  ClientId,
  employeeid,
  selectedDepartmentId,
  userRoleId,
  departmentList,
  roleList,
  AllDepartmentList,
  Menulist,
  leaveCategoryList,
  userList,
  userInfo,
  loadingRoute,
  tabId,
  locationList
}) {
  const [leaveList, setLeaveList] = useState([]);
  const [leaveCatgeory, setLeaveCatgeory] = useState([]);
  const [displayTaskLoader, setDisplayTaskLoader] = useState(false);
  const [displayLeaveModal, toggleDisplayLeaveModal] = useState(false);
  const [leaveDetails, setLeaveDetails] = useState({});
  const [leaveID, setLeaveID] = useState();
  const [havingCancel, sethavingCancel] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [leaveSummary, setLeaveSummary] = useState({});
  const [displayLeaveReportLoader, toggleLeaveReportLoader] = useState(false);
  const [staffDepartmentLeaveModal, toggleStaffDepartmentLeaveModal] =
    useState(false);
  const [selectedLeaveTypeId, setSelectedLeaveTypeId] = useState("");
  const [selectedLeaveType, setSelectedLeaveType] = useState("");
  const crmManagingOfficeList = useSelector(getCRMManagingOfficeList)
  const CountryFilterResourcePlanning = useSelector(getCountryFilterResourcePlanningList);
  const [form] = Form.useForm();
  const filteruser = userList?.filter(
    (item) => item?.userid === userInfo.userid
  );
  const [selectedManagingOffice, setSelectedManagingOffice] = useState(filteruser[0]?.managingoffice);
  const [CSVDepartmentLeave, setCSVDepartmentLeave] = useState([]);

  // ── WFH state (new) ─────────────────────────────────────────────────────────
  const [wfhList, setWfhList] = useState([]);
  const [wfhLoader, setWfhLoader] = useState(false);
  const [wfhPreviewOpen, setWfhPreviewOpen] = useState(false);
  const [wfhPreviewUrl, setWfhPreviewUrl] = useState("");
  const [wfhPreviewType, setWfhPreviewType] = useState("");
  const [wfhPreviewLoading, setWfhPreviewLoading] = useState(false);

  const containerRef = useRef(null);
  const csvLinkDepartment = useRef();

  const locationMap = locationList.reduce((acc, loc) => {
    acc[loc.location_id] = loc;
    return acc;
  }, {});

  const updatedLeaveCategory = leaveCategoryList.map((leave) => {
    const matchedCountries = leave.locationId
      ?.map((id) => locationMap[id]?.country)
      .filter(Boolean); // remove undefined

    return {
      ...leave,
      country: matchedCountries, // ["Uganda", "Kenya", ...]
    };
  });

  const filteredLeaveCategory = updatedLeaveCategory.filter((leave) => {
    // normalize selectedManagingOffice to array
    const selectedCountries = Array.isArray(selectedManagingOffice)
      ? selectedManagingOffice
      : [selectedManagingOffice];

    // check intersection
    return leave.country?.some((country) =>
      selectedCountries.includes(country)
    );
  });

  // const filterLeavecategory = filteredLeaveCategory?.filter((val) =>
  //   val?.locationId?.includes(filteruser[0]?.baselocationid)
  // );

  const filterUser = userList?.find((val) => val?.userid === userInfo?.userid);


  useEffect(() => {
    let leaveStatistics = {};

    filteredLeaveCategory?.forEach((category) => {
      leaveStatistics[category.leaveCategoryId] = {
        available: 0,
        consumed: 0,
        location: category?.locationId
      };
    });



    const approvedLeaves = leaveCatgeory.filter((item) => {
      const userid = item.userid;
      const user = userList.find((user) =>
        filterUser?.managingoffice?.includes("Head Office")
          ? user.userid === userid
          : user.userid === userid &&
          user?.managingoffice === filterUser?.managingoffice
      );
      const isActiveUser = user?.statusid === "1";

      return isActiveUser && item.status_id === "5";
    });

    approvedLeaves.forEach((leave) => {
      const leaveCategoryName = leave?.leave_category_id;
      if (!leaveStatistics[leaveCategoryName] || !leaveStatistics[leaveCategoryName]?.location?.includes(leave?.baselocationid)) {
        return;
      }
      leaveStatistics[leaveCategoryName].consumed += parseFloat(
        leave.number_of_days
      );
    });

    const updatedLeaveData = filteredLeaveCategory?.map((category) => {


      const categoryName = category.leaveCategoryName;
      const activeUserList = userList.filter((user) => user.statusid === "1");
      const headOfficeUserList = activeUserList?.filter((val) => category?.locationId?.includes(val?.baselocationid))
      let countryBasedUserList = activeUserList?.filter((item) => {
        const findUser = userList?.find((user) => {
          return user.userid === item?.userid;
        });
        const userDetails = some(findUser?.managingoffice, (value) =>
          includes(filteruser[0]?.managingoffice, value)
        );
        return userDetails;
      });
      let allLeaveData = filteruser[0]?.managingoffice.includes("Head Office")
        ? headOfficeUserList
        : countryBasedUserList;

      const userCount = allLeaveData?.filter((user) => {
        const eligibleGender = category.eligible.toLowerCase();
        if (eligibleGender === "both") {
          return true;
        } else {
          const userGender = user.gender.toLowerCase();
          return eligibleGender === userGender;
        }
      }).length;

      return {
        categoryName: categoryName,
        id: category.leaveCategoryId,
        data: [
          {
            type: "available",
            value:
              // userCount * parseInt(category.numberOfLeaves) || 0,
              userCount * parseInt(category.numberOfLeaves) || 0,
          },
          {
            type: "consumed",
            value: leaveStatistics[category.leaveCategoryId]?.consumed || 0,
          },
        ],
      };
    });


    // const updatedLeaveData = leaveCatgeory?.map((category) => {
    //   const categoryName = category?.leave_category_name;

    //   // 1️⃣ Get all active users
    //   const activeUsers = userList.filter(
    //     (user) => user.statusid === "1"
    //   );

    //   const userCount = activeUsers.length;

    //   return {
    //     categoryName,
    //     id: category.leaveCategoryId,
    //     data: [
    //       {
    //         type: "available",
    //         value: userCount * Number(category.numberOfLeaves || 0),
    //       },
    //       {
    //         type: "consumed",
    //         value:
    //           leaveStatistics?.[category.leaveCategoryId]?.consumed || 0,
    //       },
    //     ],
    //   };
    // });


    setLeaveSummary(updatedLeaveData);
  }, [leaveCatgeory, userList, leaveCategoryList, selectedManagingOffice]);

  const handleFormChange = (value) => {
    setSelectedManagingOffice(value || "");
    getLeaveList(value);
  };

  const handleFormChangeLeave = (value) => {

    setSelectedManagingOffice(value || "");
    getLeaveListCategories(value);
  };



  const openDetailWindow = (name, id) => {
    setSelectedLeaveTypeId(id);
    setSelectedLeaveType(`${name} Report`);
    toggleStaffDepartmentLeaveModal(true);
  };

  useEffect(() => {
    form.setFieldsValue({
      managingoffice: []
    });
  }, []);

  useEffect(() => {
    if (loadingRoute || tabId) {
      getLeaveList();
      getLeaveListCategories();
    }
  }, [loadingRoute, tabId]);

  function getDates() {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();

    const startDate = new Date(currentYear - 2, 0, 1);
    const endDate = new Date(currentYear + 1, 11, 31);

    return {
      startDate,
      endDate,
    };
  }

  const dates = getDates();

  const ApproveOk = async (reason) => {
    return new Promise(async (resolve) => {
      await approveRejectCancelLeave2(5, reason, havingCancel);
      resolve();
    }).catch((err) => console.log("[ApproveOk] Error-->", err));
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleOk = () => {
    setLoading(true);
    ApproveOk();
  };

  const getLeaveList = async (country) => {
    return new Promise(async (resolve, reject) => {
      setLeaveList([]);

      setDisplayTaskLoader(true);
      const { code, leaves = [] } = await CALL_API(
        `leave-list/${ClientId}`,
        "post",
        {
          status_id: "4",
          // department_id: selectedDepartmentId,
          officesupervisorid: [""],
          start_date: dates.startDate,
          end_date: dates.endDate,
          country: country ? [country] : filteruser[0]?.managingoffice,
          ...(filteruser[0]?.roleid?.includes("2") && { superAdmin: true })
        }
      );

      setDisplayTaskLoader(false);
      if (includes([STATUS_CODE.SUCCESS, STATUS_CODE.RECORD_NOT_FOUND], code)) {
        setLeaveList(leaves.reverse());

        resolve(leaves);
      } else {
        reject([]);
      }
    });
  };

   const getWfhList = async () => {
    setWfhList([]);
    setWfhLoader(true);
    try {
      const dates = getDates();
      const {response,status} = await CALL_FEATCH_API(
        `wfh/getwfhrequest`,
        "post",
        {
          requestType: "all",
          // officesupervisorid: employeeid,
          // country: filterUser?.managingoffice?.[0] ?? filterUser?.country ?? "",
          startDate: getMySqlDate(dates.startDate),
          endDate: getMySqlDate(dates.endDate),
          statusId: "0",  }
      );
      if (status === "SUCCESS") {
        const mapped = (response ?? []).map((item) => ({
          ...item,
          wfhStartDate: item?.startDate,
          wfhEndDate: item?.endDate,
          wfhNoofDays: item?.noOfDays,
          wfhReason: item?.reason,
          requestId: item?.wfhId,
          fileName: item?.attachedDocuments?.[0]?.fileName || "",
          objectKey: item?.attachedDocuments?.[0]?.objectKey || "",
          reportingManager: item?.officeSupervisorId,
          approved_rejected_byName: item?.approved_rejected_byName || "",
          rejectReason: item?.rejectReason || "",
        }));
        setWfhList(mapped);
      } else {
        setWfhList([]);}
    } catch (error) {
      console.error("[getWfhList] Error-->", error);
    } finally {
      setWfhLoader(false);
    }
 };

  useEffect(() => {
    getLeaveList();
    getWfhList();
  }, []);

  const getLeaveListCategories = async (country) => {
    return new Promise(async (resolve, reject) => {
      setLeaveCatgeory([]);

      if (selectedDepartmentId) {
        toggleLeaveReportLoader(true);
        const { code, response = [] } = await CALL_API(
          `employee/allleave`,
          "post",
          {
            clientId: ClientId,
            year: new Date().getFullYear().toString(),
            country: country ? [country] : filteruser[0]?.managingoffice,
          }
        );

        toggleLeaveReportLoader(false);
        if (
          includes([STATUS_CODE.SUCCESS, STATUS_CODE.RECORD_NOT_FOUND], code)
        ) {
          setLeaveCatgeory(response);

          resolve(response);
        } else {
          reject([]);
        }
      } else {
        reject([]);
      }
    });
  };

  const approveRejectCancelLeave2 = async (
    statusId,
    declined_reason = "",
    is_leave_cancel_request
  ) => {
    return new Promise(async (resolve) => {
      const { code } = await CALL_API(
        `approve-reject-cancel-leave/${ClientId}`,
        "post",
        {
          departmentId: selectedDepartmentId,
          user_leave_id: leaveID,
          status_id: statusId.toString(),
          declined_reason,
          is_cancel_request: is_leave_cancel_request,
          start_date: leaveDetails?.new_start_date
            ? getMySqlDate(leaveDetails?.new_start_date)
            : getMySqlDate(leaveDetails?.start_date),
          end_date: leaveDetails?.new_end_date
            ? getMySqlDate(leaveDetails?.new_end_date)
            : getMySqlDate(leaveDetails?.end_date),
        }
      );

      if (code === STATUS_CODE.SUCCESS) {
        setLoading(false);
        setIsModalOpen(false);
        message.success(`Leave has been approved`);
        getLeaveList();
      } else {
        message.error(`Something went wrong. Please try again.`);
      }
      resolve();
    });
  };

  const paginationOptions = {
    showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
    pageSize: 10,
    showSizeChanger: false,
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "fullname",
      key: "fullname",
      width: "10%",
      sorter: (a, b) => a.fullname.localeCompare(b.fullname),
    },
    {
      title: "Employee ID",
      dataIndex: "employeeid",
      key: "employeeid",
      width: "7%",
      sorter: (a, b) => a.employeeid.localeCompare(b.employeeid),
    },
    // {
    //   title: "Department",
    //   dataIndex: "department_name",
    //   key: "department_name",
    //   width: "10%",
    // },
    {
      title: "Start Date",
      dataIndex: "start_date",
      key: "start_date",
      width: "10%",
      sorter: (a, b) => new Date(a.start_date) - new Date(b.start_date),
      render: (_, record) => {
        if (
          record.new_start_date === "null" ||
          record.new_start_date === "" ||
          record.new_start_date === null
        ) {
          const dateFormat = moment(record.start_date).format("DD MMM YYYY");
          const getdayAlone = moment(record.start_date).format("dddd");
          return `${dateFormat} - ${getdayAlone}`;
        } else {
          const dateFormat = moment(record.new_start_date).format(
            "DD MMM YYYY"
          );
          const getdayAlone = moment(record.new_start_date).format("dddd");

          return `${dateFormat} - ${getdayAlone}`;
        }
      },
    },

    {
      title: "End Date",
      dataIndex: "end_date",
      key: "end_date",
      width: "10%",
      sorter: (a, b) => new Date(a.end_date) - new Date(b.end_date),
      render: (_, record) => {
        if (
          record.new_end_date === "null" ||
          record.new_end_date === "" ||
          record.new_end_date === null
        ) {
          const dateFormat = moment(record.end_date).format("DD MMM YYYY");
          const getdayAlone = moment(record.end_date).format("dddd");

          return `${dateFormat} - ${getdayAlone}`;
        } else {
          const dateFormat = moment(record.new_end_date).format("DD MMM YYYY");
          const getdayAlone = moment(record.new_end_date).format("dddd");

          return `${dateFormat} - ${getdayAlone}`;
        }
      },
    },
    {
      title: "Days",
      dataIndex: "number_of_days",
      key: "number_of_days",
      width: "7%",
      sorter: (a, b) => parseFloat(a.number_of_days) - parseFloat(b.number_of_days),
      render: (_, record) => {
        if (
          record.new_number_of_days === null ||
          record.new_number_of_days === "" ||
          record.new_number_of_days === "null"
        ) {
          return record.number_of_days;
        } else {
          return record.new_number_of_days;
        }
      },
    },
    {
      title: "Leave Type",
      dataIndex: "leave_category_name",
      key: "leave_category_name",
      width: "10%",
      sorter: (a, b) => a.leave_category_name.localeCompare(b.leave_category_name),
    },
    {
      title: "Amended Leave",
      dataIndex: "having_cancel_request",
      key: "having_cancel_request",
      width: "10%",
      sorter: (a, b) => a.having_cancel_request.localeCompare(b.having_cancel_request),
      render: (having_cancel_request) => {
        if (having_cancel_request === "1") {
          return "Yes";
        } else {
          return "No";
        }
      },
    },
    {
      title: "Applied On",
      dataIndex: "applied_date",
      key: "applied_date",
      width: "10%",
      sorter: (a, b) => new Date(a.created_at) - new Date(b.created_at),
      render: (_, record) => {
        const dateFormat = moment(record.created_at).format("DD MMM YYYY");
        return dateFormat;
      },
    },
  ];

  const CSVHeaders = [
    { label: "Employee ID", key: "Employee ID" },
    { label: "Name", key: "Name" },
    { label: "Available Leaves", key: "Available Leaves" },
    { label: "Consumed Leaves", key: "Consumed Leaves" },
    { label: "Total Leaves", key: "Total Leaves" },
  ];


  const prepareCSV = (event, done) => {
    if (!Array.isArray(leaveSummary) || leaveSummary.length === 0) {
      message.warning("No data available to download");
      done(false);
      return;
    }

    const csvData = reduce(
      leaveSummary,
      (result, leave) => {
        result.push({
          "Employee ID": leave.id,
          Name: leave.categoryName,
          "Available Leaves": leave.data[0].value - leave.data[1].value,
          "Consumed Leaves": leave.data[1].value,
          "Total Leaves": leave.data[0].value,
        });
        return result;
      },
      []
    );

    setCSVDepartmentLeave(csvData);
    done(true);
  };

  const handlePreviewClick = async (record) => {
    try {
      const ext = record?.fileName?.split(".")?.pop();
      setWfhPreviewLoading(true);
      const { url, status, response } = await CALL_FEATCH_API(
        `document-list/${ClientId}`,
        "post",
        {
          method: "preview-wfh-document",
          userId: record?.userId || "",
          wfhId: record?.requestId,
          fileKey: record?.objectKey || "",
        }
      );
      if (status === "SUCCESS" || response?.code === "SUCCESS") {
        if (["jpg", "jpeg", "png", "svg", "pdf"].includes(ext)) {
          setWfhPreviewUrl(response?.url);
          setWfhPreviewType(["jpg", "jpeg", "png", "svg"].includes(ext) ? "image" : "pdf");
          setWfhPreviewOpen(true);
        } else {
          window.open(response?.url ?? url, "_blank");
        }
      } else {
        message.error("Preview failed. Try again.");
      }
    } catch (err) {
      message.error("Something went wrong");
    } finally {
      setWfhPreviewLoading(false);
}
  };

    const wfhColumns = [
       {
         title: "Name",
         dataIndex: "userId",
         key: "name",
         width: "12%",
         sorter: (a, b) => {
           const nameA =
             userList?.find((u) => u.userid === a.userId)?.fullname ?? a.userId;
           const nameB =
             userList?.find((u) => u.userid === b.userId)?.fullname ?? b.userId;
           return nameA.localeCompare(nameB);
         },
         render: (userId) => {
           const user = userList?.find((u) => u.userid === userId);
           return user?.fullname ?? userId;
         },
       },
       {
         title: "Employee ID",
         dataIndex: "userId",
         key: "employeeid",
         width: "10%",
         sorter: (a, b) => {
           const idA =
             userList?.find((u) => u.userid === a.userId)?.employeeid ?? "";
           const idB =
             userList?.find((u) => u.userid === b.userId)?.employeeid ?? "";
           return idA.localeCompare(idB);
         },
         render: (userId) => {
           const user = userList?.find((u) => u.userid === userId);
           return user?.employeeid ?? "-";
         },
       },
       {
         title: "Start Date",
         dataIndex: "wfhStartDate",
         key: "wfhStartDate",
         width: "12%",
         sorter: (a, b) => new Date(a.wfhStartDate) - new Date(b.wfhStartDate),
         render: (wfhStartDate) =>
           wfhStartDate
             ? `${moment(wfhStartDate).format("DD MMM YYYY")} - ${moment(wfhStartDate).format("dddd")}`
             : "-",
       },
       {
         title: "End Date",
         dataIndex: "wfhEndDate",
         key: "wfhEndDate",
         width: "12%",
         sorter: (a, b) => new Date(a.wfhEndDate) - new Date(b.wfhEndDate),
         render: (wfhEndDate) =>
           wfhEndDate
             ? `${moment(wfhEndDate).format("DD MMM YYYY")} - ${moment(wfhEndDate).format("dddd")}`
             : "-",
       },
       {
         title: "Total Days",
         dataIndex: "wfhNoofDays",
         key: "wfhNoofDays",
         width: "8%",
         sorter: (a, b) => (a.wfhNoofDays ?? 0) - (b.wfhNoofDays ?? 0),
         render: (wfhNoofDays) => wfhNoofDays ?? "-",
       },
       {
         title: "Attachment",
         dataIndex: "fileName",
         key: "fileName",
         width: "10%",
         render: (fileName, record) => {
           if (!fileName) return "-";
           return (
             <a
               onClick={(e) => {
                 e.preventDefault();
                 e.stopPropagation();
                 handlePreviewClick(record);
               }}
               style={{ display: "flex", alignItems: "center", gap: 4, color: "#2d53da" }}
             >
               <PaperClipOutlined />
               {fileName}
             </a>
           );
         },
       },
       {
         title: "Applied On",
         dataIndex: "createdAt",
         key: "createdAt",
         width: "10%",
         sorter: (a, b) => new Date(a.createdAt) - new Date(b.createdAt),
         render: (createdAt) =>
           createdAt ? moment(createdAt).format("DD MMM YYYY") : "-",
       },
       {
         title: "Reason for WFH",
         dataIndex: "wfhReason",
         key: "wfhReason",
         width: "16%",
         render: (wfhReason) => wfhReason || "-",
       },
     ];


  // if (
  //   Menulist?.find((item) => item?.key === "approvals" && item?.permission.edit)
  // ) {
  //   columns.push({
  //     title: "Action",
  //     dataIndex: "address",
  //     key: "address",
  //     width: "10%",
  //     render: (_, record) => (
  //       <>
  //         <Tooltip title="View Leave">
  //           <EyeFilled
  //             className="action-button"
  //             onClick={() => viewLeave(record, true)}
  //           />
  //         </Tooltip>
  //         {(userRoleId === 1 || userRoleId === 6) && (
  //           <Tooltip title="Remind HOD & Assistant HOD" placement="left">
  //             <BellFilled
  //               className="action-button"
  //               onClick={() => remindSuperior(record)}
  //             />
  //           </Tooltip>
  //         )}
  //       </>
  //     ),
  //   });
  // }

  const filterleavereport = leaveList.filter(
    // (item) => item.status_id === "4" && item.department_id == selectedDepartment
    (item) => {
      const findUser = userList?.find((user) => {
        return user.userid === item?.userid;
      });
      if (filteruser[0]?.OfficeSupervisorId === "none" || userInfo?.roleId === "2") {
        return item;
      } else {
        const isSameCountry = some(findUser?.managingoffice, (value) =>
          includes(filteruser[0]?.managingoffice, value)
        );
        return isSameCountry;
      }
    }
  );

  const viewLeave = (leaveObject, isViewOnly = false) => {
    if (
      Menulist?.find(
        (item) => item?.key === "approvals" && item?.permission.edit
      )
    ) {
      toggleDisplayLeaveModal(true);
      setLeaveDetails({
        ...leaveObject,
        isViewOnly,
      });
    }
  };

  const remindSuperior = (leaveRecord) => {
    const { confirm } = Modal;
    confirm({
      icon: "",
      closable: true,
      content:
        "Do you want to send reminder notification to HOD & Assistant HOD?",
      async onOk() {
        const { user_leave_id, user_id } = leaveRecord;
        const { code } = await CALL_API(
          "leave-notification-to-hod-assistant-hod",
          "post",
          {
            user_leave_id,
            user_id,
          }
        );
        if (code === STATUS_CODE.SUCCESS) {
          message.success(`Notification has been sent.`);
        } else {
          message.error(`Something went wrong. Please try again.`);
        }
      },
      onCancel() { },
    });
  };

  if (loadingRoute) {
    return (
      <StyledLoader>
        <div>
          <Spin size="large" />
        </div>
      </StyledLoader>
    );
  }

  const uniquemanagingOffice = uniqBy(
    crmManagingOfficeList?.map((item) => {
      return { label: item?.Label, value: item?.Value };
    }),
    "value"
  );

  const tabItems = [
      {
        key: "leave",
        label: `Leave Approvals${filterleavereport.length > 0 ? ` (${filterleavereport.length})` : ""}`,
        children: (
          <>
            {/* Waiting for Approval table */}
            {Menulist?.find(
            (item) => item?.key === "approvals" && item?.permission.view
          ) && (
              <Col
                md={24}
                sm={24}
                xs={24}
                xl={24}
                ref={containerRef}
                className="mt-2"
              >
                <StyledChartContainer>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      marginBottom: "10px",
                    }}
                  >
                    <StyledTitle>
                      Waiting for Approval{" "}
                      {filterleavereport?.length > 0
                        ? `(${filterleavereport?.length})`
                        : null}
                    </StyledTitle>

                    <Col xs={24} sm={24} md={12} lg={8} xl={6}>
                      <Form form={form} layout="vertical">
                        <Form.Item name="managingoffice" >
                          {filteruser[0]?.roleid?.includes("2") &&
                            <Select
                              showSearch
                              placeholder="Select Country"
                              labelInValue
                              onChange={(val) => {
                                // val = { label: "Kenya", value: "Kenya" }
                                form.setFieldsValue({ managingoffice: val });
                                handleFormChange(val?.label);
                              }}
                            >
                              {uniqBy(
                                CountryFilterResourcePlanning?.map((item) => ({
                                  label: item.country,
                                  value: item.country,
                                })),
                                "value"
                              )?.map((option) => (
                                <Select.Option key={option.value} value={option.value}>
                                  {option.label}
                                </Select.Option>
                              ))}
                            </Select>

                          }
                        </Form.Item>
                      </Form>
                    </Col>
                  </div>
                  <Spin spinning={displayTaskLoader}>
                    <StyledTable
                      dataSource={filterleavereport}
                      columns={columns}
                      rowClassName={(record, index) =>
                        index % 2 === 0 ? "" : "non-white"
                      }
                      onRow={(record) => {
                        return {
                          onClick: () => viewLeave(record, true),
                        };
                      }}
                      rowKey="user_leave_id"
                      pagination={
                        filterleavereport.length > 10 ? paginationOptions : false
                      }
                    />
                  </Spin>
                  <LeaveFormModel
                    isModalVisible={displayLeaveModal}
                    closeModal={() => toggleDisplayLeaveModal(false)}
                    userRoleId={userRoleId}
                    leaveDetails={leaveDetails}
                    toggleDisplayLeaveModal={toggleDisplayLeaveModal}
                    getLeaveList={getLeaveList}
                    setIsModalOpen={setIsModalOpen}
                    setLeaveID={setLeaveID}
                    sethavingCancel={sethavingCancel}
                    ClientId={ClientId}
                  />
                </StyledChartContainer>
              </Col>
            )}
  
            {/* Overall My Team Leave Report */}
            <Col md={24} sm={24} xs={24} xl={24} className="mt-2">
            <Spin spinning={displayLeaveReportLoader}>
              <StyledLeaveContainer>
                <Row justify="space-between" align="middle">
                  <Col>
                    <StyledTitle className="mb-3">Overall Leave Report</StyledTitle>
                  </Col>
                  <Col className="mb-2"
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      alignItems: "center",
                      gap: "12px",
                    }}
                  >
                    <CSVLink
                      headers={CSVHeaders}
                      data={CSVDepartmentLeave}
                      filename="Department Leave List.csv"
                      asyncOnClick={true}
                      onClick={prepareCSV}
                      ref={csvLinkDepartment}
                    >
                      <ButtonOutlined
                        disabled={
                          !Array.isArray(leaveSummary) || leaveSummary.length === 0
                        }
                      >
                        Export CSV file
                      </ButtonOutlined>
                    </CSVLink>

                    {filteruser[0]?.roleid?.includes("2") && (
                      <Form form={form} layout="vertical" style={{ marginBottom: 0 }}>
                        <Form.Item name="managingoffice1" style={{ marginBottom: 0 }}>
                          <Select
                            showSearch
                            placeholder="Select Country"
                            labelInValue
                            style={{ width: 200 }}
                            onChange={(val) => {
                              form.setFieldsValue({ managingoffice: val });
                              handleFormChangeLeave(val.label);
                            }}
                          >
                            {uniqBy(
                              CountryFilterResourcePlanning?.map((item) => ({
                                label: item.country,
                                value: item.country,
                              })),
                              "value"
                            )?.map((option) => (
                              <Select.Option
                                key={option.value}
                                value={option.value}
                                label={option.label}
                              >
                                {option.label}
                              </Select.Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </Form>
                    )}
                  </Col>

                </Row>


                <Row
                  gutter={{
                    xs: 8,
                    sm: 12,
                    md: 16,
                  }}
                >
                  {Array.isArray(leaveSummary) &&
                    leaveSummary.map((value, index) => (
                      <Col
                        xs={24}
                        sm={24}
                        md={24}
                        lg={12}
                        xl={8}
                        key={value.categoryName}
                        onClick={() =>
                          openDetailWindow(value.categoryName, value.id)
                        }
                      >
                        <LeaveDonutChart
                          iconName={LEAVE_ICON[7]}
                          title={value.categoryName}
                          data={value.data}
                          color={getColor(index)}
                        />
                      </Col>
                    ))}
                </Row>
              </StyledLeaveContainer>
            </Spin>
          </Col>
          </>
        ),
      },
      {
        key: "wfh",
        label: `WFH Requests${wfhList.length > 0 ? ` (${wfhList.length})` : ""}`,
        children: (
          <Col md={24} sm={24} xs={24} xl={24} className="mt-2">
            <StyledChartContainer>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: "10px",
                }}
              >
                <StyledTitle>
                  WFH Requests
                  {wfhList.length > 0 ? ` (${wfhList.length})` : null}
                </StyledTitle>
              </div>
              <Spin spinning={wfhLoader}>
                <StyledTable
                  dataSource={wfhList}
                  columns={wfhColumns}
                  rowClassName={(record, index) =>
                    index % 2 === 0 ? "" : "non-white"
                  }
                  rowKey="requestId"
                  pagination={wfhList.length > 10 ? paginationOptions : false}
                />
              </Spin>
            </StyledChartContainer>
          </Col>
        ),
      },
    ];


  return (
    <>
      <>
        <StyledRow gutter={16}>

          <Col md={24} sm={24} xs={24} xl={12}>
            <AttendanceBarChart isHrDashboard={true} employeeid={employeeid} managingoffice={selectedManagingOffice} />
          </Col>

          <Col md={24} sm={24} xs={24} xl={12}>
            <LocationBasedPresentStaff
              employeeid={employeeid}
              isHrDashboard={true}
            />
          </Col>

          <Col md={24} sm={24} xs={24} xl={24} className="mt-2">
            <Tabs defaultActiveKey="leave" items={tabItems} />
        </Col>
        </StyledRow>
      </>
      <Modal
        title="Approve leave"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={[
          <Button key="back" onClick={handleCancel}>
            No
          </Button>,
          <Button
            key="submit"
            type="primary"
            loading={loading}
            onClick={handleOk}
          >
            Yes
          </Button>,
        ]}
      >
        <p>Are you sure you want to approve leave?</p>
      </Modal>

      <DepartmentStaffLeaveBalance
        displayModal={staffDepartmentLeaveModal}
        toggleModal={() => toggleStaffDepartmentLeaveModal(false)}
        leaveTypeId={selectedLeaveTypeId}
        selectedDepartmentId={selectedDepartmentId}
        leaveName={selectedLeaveType}
        leaveList={leaveList}
        leaveCategoryList={leaveCategoryList}
        leaveCatgeory={leaveCatgeory}
        all={false}
      />

       <Modal
        open={wfhPreviewOpen}
        footer={null}
        centered
        width={900}
        onCancel={() => { setWfhPreviewOpen(false); setWfhPreviewUrl(""); }}
      >
        <Spin spinning={wfhPreviewLoading}>
          {wfhPreviewType === "image" ? (
            <img src={wfhPreviewUrl} alt="preview" style={{ width: "100%" }} />
          ) : (
            <iframe
              src={wfhPreviewUrl}
              title="preview"
              style={{ width: "100%", height: "75vh", border: "none" }}
            />
          )}
        </Spin>
      </Modal>
    </>
  );
}

const mapStateToProps = (state) => ({
  loadingRoute: getLoadingRoute(state),
  locationList: getLocations(state),
});

export default connect(mapStateToProps, null)(HrDashboard);